import { ModelSettingsView } from "@/views/studio/ModelSettingsView";

/**
 * 本机设置（`specs/07` §4 · `specs/13` PR-1301）。
 *
 * 模型配置原先渲染在「运行指标」页首。那个导航项按 `specs/12` 讲的是 HTTP 与业务指标，
 * **名实不符 ⇒ 配置入口事实上不可发现**（需求方 2026-10-07 反馈找不到它在哪）。
 * 本视图把它独立成「设置」入口，`SystemView` 回归纯指标视图。
 *
 * ⚠️ **不套 `RemoteState`**：模型配置有自己的错误态（只支持本机访问，失败原因与
 * "项目数据加载失败"不是同一类，恢复动作也不同）。套进来会让两种失败共用一句文案，
 * 那正是 `specs/14` §7 要消灭的信息损耗。
 *
 * @dataSource remote
 */
export function SettingsView() {
  return (
    <div className="page-scroll">
      <div className="page-width">
        <header className="page-heading">
          <div>
            <span className="eyebrow">本机安装级配置</span>
            <h2>配置生成所用的模型</h2>
          </div>
        </header>
        <ModelSettingsView />
      </div>
    </div>
  );
}
